import {MenuItem, MenuRoute} from "../Sidebar.types";

const removeAllAfterSlashInString = (path: string) => {
  if (!path) return;
  return path.substring(0, path.lastIndexOf("/") + 1);
};

export const retrieveBestMatchRouter = (
  menu: MenuItem[],
  activePath: string,
) => {
  let found: MenuRoute = {} as MenuRoute;

  const foundReassignmentBesedOnActivePath = (route: MenuRoute) => {
    if (route.path === activePath) {
      found = route;
    }
  };

  const foundReassignmentBesedOnLastString = (route: MenuRoute) => {
    const routeWithOutLastString = removeAllAfterSlashInString(route.path);
    const activePathWithoutLastString = removeAllAfterSlashInString(activePath);

    if (routeWithOutLastString === activePathWithoutLastString) {
      found = route;
    }
  };

  menu.forEach((menuItem) => {
    menuItem.routes.forEach(foundReassignmentBesedOnActivePath);

    if (menuItem.subCollection) {
      menuItem.subCollection?.forEach((subCol) => {
        subCol.routes?.forEach(foundReassignmentBesedOnActivePath);
      });
    }

    if (Object.keys(found).length === 0) {
      menuItem.routes.forEach(foundReassignmentBesedOnLastString);

      //Esse segundo if com a mesma condição avalia se o length com as keys do objeto 'found'
      // continua o mesmo, porque ele pode ter mudado dentro do forEach anterior.
      if (Object.keys(found).length === 0) {
        menuItem.subCollection?.forEach((subCol) => {
          subCol.routes?.forEach(foundReassignmentBesedOnLastString);
        });
      }
    }
  });
  return found;
};
